import {
  SET_TABLE_DATA,
  HAS_ERROR,
  IS_LOADING,
  READ_ALL,
  SET_LAST_UPDATE,
  SET_QUERY_LOADING,
} from 'redux/constants/peopleSat';
import { TABLES_ITEMS_PER_PAGE } from 'settings';

export const initialState = {
  error: null,
  isLoading: false,
  items: [],
  lastUpdate: null,
  queryIsLoading: false,
  table: {
    headers: [],
    pagination: {
      perPageOptions: TABLES_ITEMS_PER_PAGE,
    },
    rows: [],
    total: 0,
  },
};

function peopleSatReducer(state = initialState, action) {
  const { payload = {}, type } = action;
  const {
    error,
    isLoading,
    items,
    lastUpdate,
    queryIsLoading,
    table,
  } = payload;

  switch (type) {
    default: return state;

    case SET_TABLE_DATA:
      return {
        ...state,
        table,
      };

    case HAS_ERROR:
      return {
        ...state,
        error,
      };

    case IS_LOADING:
      return {
        ...state,
        isLoading,
      };

    case READ_ALL:
      return {
        ...state,
        items,
      };

    case SET_LAST_UPDATE:
      return {
        ...state,
        lastUpdate,
      };

    case SET_QUERY_LOADING:
      return {
        ...state,
        queryIsLoading,
      };
  }
}

export default peopleSatReducer;
